.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
